import React, { MutableRefObject } from 'react';
import useMobile from '@/services/hooks/useMobile';
import { BulbAiIcon, TipsCard, Typography, palette } from '@dev/ee-components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from '@material-ui/core';
import { isReseller } from '@/services/Secuirty';
import { AiTextSetInputValue } from '@/store/aiText/actions';
import { links } from '@/services/dictionaries/links';
import { TipsCardsWrapper, TipsHeader, TipsWrapper, TipsContent } from './styles';

export const AiTextTips = ({ inputWrapperRef }: { inputWrapperRef: MutableRefObject<HTMLDivElement> }): JSX.Element => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMobile();

    const onItemClick = (request: string): void => {
        dispatch(AiTextSetInputValue(request));
        inputWrapperRef.current?.querySelector('input')?.focus();
    };

    return (
        <TipsWrapper>
            <TipsContent>
                <TipsHeader>
                    <Typography variant="h3">{t('examples')}</Typography>
                </TipsHeader>
                <TipsCardsWrapper>
                    <TipsCard
                        cards={[
                            {
                                icon: <BulbAiIcon color={palette.gray[6]} />,
                                text: (
                                    <Typography variant="body1" bodyVariant="buttonLabel">
                                        {t('aitexttool_exampleprompt1')}
                                    </Typography>
                                ),
                                onClick: () => onItemClick(t('aitexttool_exampleprompt1')),
                            },
                            {
                                icon: <BulbAiIcon color={palette.gray[6]} />,
                                text: (
                                    <Typography variant="body1" bodyVariant="buttonLabel">
                                        {t('aitexttool_exampleprompt2')}
                                    </Typography>
                                ),
                                onClick: () => onItemClick(t('aitexttool_exampleprompt2')),
                            },
                            {
                                icon: <BulbAiIcon color={palette.gray[6]} />,
                                text: (
                                    <Typography variant="body1" bodyVariant="buttonLabel">
                                        {t('aitexttool_exampleprompt3')}
                                    </Typography>
                                ),
                                onClick: () => onItemClick(t('aitexttool_exampleprompt3')),
                            },
                            {
                                icon: <BulbAiIcon color={palette.gray[6]} />,
                                text: (
                                    <Typography variant="body1" bodyVariant="buttonLabel">
                                        {t('aitexttool_exampleprompt4')}
                                    </Typography>
                                ),
                                onClick: () => onItemClick(t('aitexttool_exampleprompt4')),
                            },
                        ]}
                        isMobile={isMobile}
                        useGrid
                        gridRowGap="12px"
                        gridColumnGap="12px"
                    />
                </TipsCardsWrapper>
                <Typography variant="body1">
                    {t('aitexttool_desc')}
                    {!isReseller() && (
                        <>
                            {' '}
                            <Link target="_blank" href={links.aiTextTool}>
                                {t('learnmore')}.
                            </Link>
                        </>
                    )}
                </Typography>
            </TipsContent>
        </TipsWrapper>
    );
};
